import PhoneIcon from '@mui/icons-material/PhoneEnabled';

import ResponsiveButton from '../ResponsiveButton';

const phoneNumber = '(888) 514-2944';
const formattedPhoneNumber = `+1${phoneNumber.replace(/\D/g, '')}`;

export default function PhoneButton() {
  return (
    <ResponsiveButton
      data-testid="call-button"
      href={`tel:${formattedPhoneNumber}`}
      icon={<PhoneIcon />}
    >
      {phoneNumber}
    </ResponsiveButton>
  );
}
